<script>
import baseMixin from '@/mixins/baseMixin'
import ColorSet from '@/models/general/colorSet'
import VuetifyColourClass from '@/shared/constants/core/VuetifyColourClass'
import CommentBaseAvatar from './comment-base-avatar.vue'
import CommentBaseText from './comment-base-text.vue'
import CommentBaseSubtitle from './comment-base-subtitle.vue'

export default {
  name: 'CommentBase',
  components: { CommentBaseAvatar, CommentBaseText, CommentBaseSubtitle },
  mixins: [baseMixin],
  props: {
    hideAvatar: {
      type: Boolean,
    },
    addedBy: {
      type: String,
      default: '',
    },
    avatarIcon: {
      type: String,
      default: '',
    },
    avatarColor: {
      type: ColorSet,
      default: () => null,
    },
    text: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    disableHover: {
      type: Boolean,
    },
    active: {
      type: Boolean,
    },
    color: {
      type: String,
      default: VuetifyColourClass.grey,
    },
    activeClass: {
      type: String,
      default: '',
    },
    hoverClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    defaultActiveClass() {
      return `${this.color} lighten-4`
    },
    defaultHoverClass() {
      return `${this.color} lighten-4`
    },
    hasCustomActiveClass() {
      return !!this.activeClass
    },
    hasCustomHoverClass() {
      return !!this.hoverClass
    },
    compHoverClass() {
      if (this.disableHover) return ''

      return this.hasCustomHoverClass ? this.hoverClass : this.defaultHoverClass
    },
    compActiveClass() {
      return this.hasCustomActiveClass
        ? this.activeClass
        : this.defaultActiveClass
    },
  },
}
</script>

<template>
  <v-hover v-slot="{ hover }">
    <v-sheet
      :class="[
        active ? compActiveClass : '',
        hover ? compHoverClass : '',
        isSmallOrLower ? '' : 'd-flex',
        'rounded-lg px-4 py-3 align-center',
      ]"
    >
      <div class="d-flex flex-grow-1 align-top">
        <slot v-if="!hideAvatar" name="avatar">
          <CommentBaseAvatar
            :name="addedBy"
            :icon="avatarIcon"
            :color="avatarColor"
          />
        </slot>
        <div class="overflow-wrap-anywhere">
          <slot>
            <CommentBaseText>
              {{ text }}
            </CommentBaseText>
          </slot>
          <slot name="subtitle">
            <CommentBaseSubtitle>
              {{ subtitle }}
            </CommentBaseSubtitle>
          </slot>
        </div>
      </div>
      <div class="flex-shrink-1 text-right">
        <slot name="actions"></slot>
      </div>
    </v-sheet>
  </v-hover>
</template>
